/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import AddressBlock from '../../Quote/Step02/components/AddressBlock'
import { getSettlementBasis, settlementBasisCalc } from '../../../common/SettlementBasis'
import { get } from 'lodash'

/**
 *     Import
 *     - Components
 */
import { Button } from '../../../common/Button/Button'

/**
 *     Import
 *     - Styles
 */
import './styles/Summary.css'

export default class Summary extends React.Component<any, any> {

    constructor(props: any) {
        super(props)
        this.state = {
        }
    }

    /**
     * Reset all quote data before going to next step
     *
     * @memberof Summary
     */
    componentWillUnmount() {
        if (this.props.resetQuotes) {
            this.props.resetQuotes()
        }
    }

    componentDidMount() {
        this.props.getPolicySingle(this.props.match.params.quoteId)
    }

    columnChunks = (arr, size) => {
        if (!Array.isArray(arr)) {
            throw new TypeError('Input should be Array')
        }

        if (typeof size !== 'number') {
            throw new TypeError('Size should be a Number')
        }

        let result: any = []
        for (let i = 0; i < arr.length; i += size) {
            result.push(arr.slice(i, size + i))
        }

        return result
    }

    getSumInsuredTitle = () => {
        const { policy } = this.props
        if (get(policy, 'response.isCollectors', false)) {
            return 'Collection sum insured'
        } else if (get(policy, 'response.isDealersStock', false)) {
            return 'Total dealers stock sum insured'
        } else if (get(policy, 'response.isMuseums', false)) {
            return 'Total Exhibits sum insured'
        } else if (get(policy, 'response.isWineSpirits', false)) {
            return 'Total Collection sum insured'
        } else if (get(policy, 'response.isCommercialProperty', false)) {
            return 'Total delcared value'
        } else {
            return 'Total stock sum insured'
        }
    }

    getPremiumValue = () => {
        const { policy } = this.props
        const premium = get(policy, 'response.premium', 0).toString().replace(',' , '')
        return (parseFloat(premium) - parseFloat(get(policy, 'response.policyFee', 0))).toFixed(2)
    }

    render() {

        if (this.props.policy.done === false && this.props.policy.clientName === '') {
            // this.props.history.push(`/quote/${this.props.match.params.quoteId}/step05`)
            this.props.history.push(`/dashboard`)
            return (<div />)
        }

        if ((this.props.policy.done)) {
            let policy = this.props.policy.response
            const operativeSections = this.columnChunks(policy.operativeSections, 5)
            return (
                <div className="summary noPadding">

                    <div className="summary__message">
                        <h4>Thank you</h4>
                        <h5>
                            A brief summary of your policy is below.
                            The Schedule and risk presentation documents have been emailed to you,
                            along with a copy of the policy wording.
                            The documentation will also be available in your dashboard.
                        </h5>
                    </div>

                    <div className="summary__box">
                        <div className="summary__header">
                            <div className="summary__header__title">
                                {policy.clientName}
                            </div>
                            <div className="summary__header__subtitle">
                                {policy.policyName}
                            </div>
                            <div className="summary__header__policyInfo">
                                Policy reference. <span>{policy.policyNumber}</span>
                            </div>
                        </div>
                        <div className="summary__row">
                            <div className="summary__infoBlock">
                                <div className="summary__infoBlock__title">Inception date</div>
                                <div className="summary__infoBlock__value"><span>{policy.inceptionDate}</span></div>
                            </div>
                            <div className="summary__infoBlock">
                                <div className="summary__infoBlock__title">Expiry date</div>
                                <div className="summary__infoBlock__value"><span>{policy.expiryDate}</span></div>
                            </div>
                            <div className="summary__infoBlock">
                                <div className="summary__infoBlock__title">Premium</div>
                                <div className="summary__infoBlock__value">
                                    <span>£{this.getPremiumValue()}</span> inc.IPT +
                                    <span> £{policy.policyFee}</span> Policy Fee
                                </div>
                            </div>

                        </div>
                        <div className="summary__row">
                            <div className="summary__infoBlock">
                                <div className="summary__infoBlock__title">Your commission</div>
                                <div className="summary__infoBlock__value"><span>{policy.commission}%</span></div>
                            </div>
                            <div className="summary__infoBlock">
                                <div className="summary__infoBlock__title">Excess</div>
                                <div className="summary__infoBlock__value">
                                    <span>
                                        {(typeof (policy.excess) === 'number') ?
                                            (policy.excess).toLocaleString('en-GB', {
                                                style: 'currency',
                                                currency: 'GBP',
                                            })
                                            : `£${policy.excess}`
                                        }
                                    </span>
                                </div>
                            </div>
                            <div className="summary__infoBlock">
                                <div className="summary__infoBlock__title">
                                    {this.getSumInsuredTitle()}
                                </div>
                                <div className="summary__infoBlock__value">
                                    <span>£{policy.totalSumInsured}</span>
                                </div>
                            </div>
                            {((policy.policyName === 'Collectors' || policy.isCollectors)
                                || policy.isMuseums || policy.isWineSpirits || policy.isCommercialProperty) ? null :
                                <div className="summary__infoBlock">
                                    <div className="summary__infoBlock__title">Settlement basis</div>
                                    <div className="summary__infoBlock__value">
                                        <span>
                                            {getSettlementBasis(policy.priceBasis, policy.settlementBasis)}
                                            {settlementBasisCalc(policy.settlementBasis)}%
                                        </span>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="summary__row">
                            <div className="summary__infoBlock__value">
                                <span>
                                    {(policy.policyName === 'Collectors' || policy.isCollectors
                                        || policy.isMuseums || policy.isWineSpirits) &&
                                        policy.riskLocations && (policy.riskLocations).length > 0 ?
                                        'Risk addresses' : 'Operative sections'}
                                </span>
                            </div>
                            {(policy.policyName === 'Collectors' || policy.isCollectors ||
                                policy.isMuseums || policy.isWineSpirits) &&
                                policy.riskLocations && (policy.riskLocations).length > 0 ?
                                <div className="PolicyAddressShow">
                                    {policy.riskLocations.map((r, i) => {
                                        return (
                                            <AddressBlock
                                                key={i}
                                                // id={r.id}
                                                // quoteId={parseInt(this.props.match.params.id, 10)}
                                                addressType={r.addressType}
                                                addressLine1={r.addressLine1}
                                                addressLine2={r.addressLine2}
                                                city={r.city}
                                                postcode={r.postcode}
                                                addressAllocated={r.allocated}
                                            />
                                        )
                                    })}
                                </div>
                                :
                                operativeSections.map((row, i) => (
                                    <div key={i} className="summary__infoBlock">
                                        {
                                            row.map((col, y) => (
                                                <div key={y} className="summary__infoBlock__value">{col}</div>
                                            ))
                                        }
                                    </div>
                                ))
                            }
                        </div>
                    </div>

                    <div className="quote__form__group quote__form__group--submit">
                        <Button
                            type="submit"
                            onClick={() => this.props.history.push(`/dashboard`)}
                        >
                            Return to dashboard
                        </Button>
                    </div>

                </div>
            )
        } else {
            return (<div />)
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/Quote/Summary/Summary.tsx